document.addEventListener('DOMContentLoaded',function(){
  // Header scroll
  var header=document.querySelector('.site-header');
  if(header){window.addEventListener('scroll',function(){header.classList.toggle('scrolled',window.scrollY>20)})}

  // Mobile menu
  var toggle=document.querySelector('.menu-toggle');
  var mob=document.querySelector('.mobile-menu');
  var mobClose=document.querySelector('.mobile-menu-close');
  if(toggle&&mob){
    toggle.addEventListener('click',function(){mob.classList.add('open');document.body.style.overflow='hidden'});
    if(mobClose)mobClose.addEventListener('click',closeMob);
    mob.addEventListener('click',function(e){if(e.target===mob)closeMob()});
  }
  function closeMob(){if(mob)mob.classList.remove('open');document.body.style.overflow=''}

  // Cart drawer
  var overlay=document.querySelector('.cart-overlay');
  var drawer=document.querySelector('.cart-drawer');
  var cartClose=document.querySelector('.cart-close-btn');
  document.querySelectorAll('[data-cart-open]').forEach(function(b){b.addEventListener('click',function(){openCart(true)})});
  if(cartClose)cartClose.addEventListener('click',closeCart);
  if(overlay)overlay.addEventListener('click',closeCart);

  function openCart(fetch){
    if(overlay)overlay.classList.add('open');
    if(drawer)drawer.classList.add('open');
    document.body.style.overflow='hidden';
    if(fetch)renderCart();
  }
  function closeCart(){
    if(overlay)overlay.classList.remove('open');
    if(drawer)drawer.classList.remove('open');
    document.body.style.overflow='';
  }

  // Render cart items in drawer
  function renderCart(){
    var body=document.querySelector('.cart-body');
    if(!body)return;
    body.innerHTML='<p style="text-align:center;padding:2rem;color:#888;font-size:13px;">Memuat...</p>';
    window.fetch('/cart.js').then(function(r){return r.json()}).then(function(cart){
      updateCartBadge(cart.item_count);
      // update total
      var totalEl=document.querySelector('.cart-total-row strong');
      if(totalEl)totalEl.textContent=formatMoney(cart.total_price);
      if(cart.item_count===0){
        body.innerHTML='<div class="cart-empty"><svg viewBox="0 0 24 24"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg><p>Keranjang kosong</p></div>';
        return;
      }
      var html='<div class="cart-items">';
      cart.items.forEach(function(item){
        var img=item.image?('<img src="'+item.image+'" alt="'+item.title+'" style="width:64px;height:64px;object-fit:cover;border-radius:8px;flex-shrink:0;">'):'';
        html+='<div class="cart-item" style="display:grid;grid-template-columns:64px 1fr auto;gap:1rem;align-items:center;padding:1rem 0;border-bottom:1px solid #f0f0f0;">'
          +img
          +'<div>'
          +'<p style="font-size:13px;font-weight:500;color:#1a3d2b;margin:0 0 4px;">'+item.title+'</p>'
          +(item.variant_title&&item.variant_title!=='Default Title'?'<p style="font-size:11px;color:#888;margin:0 0 6px;">'+item.variant_title+'</p>':'')
          +'<div style="display:flex;align-items:center;gap:8px;">'
          +'<button data-change-qty data-key="'+item.key+'" data-delta="-1" style="width:24px;height:24px;border:1px solid #ddd;background:#fff;border-radius:50%;cursor:pointer;font-size:14px;display:flex;align-items:center;justify-content:center;line-height:1;">−</button>'
          +'<span style="font-size:13px;min-width:20px;text-align:center;">'+item.quantity+'</span>'
          +'<button data-change-qty data-key="'+item.key+'" data-delta="1" style="width:24px;height:24px;border:1px solid #ddd;background:#fff;border-radius:50%;cursor:pointer;font-size:14px;display:flex;align-items:center;justify-content:center;line-height:1;">+</button>'
          +'</div>'
          +'</div>'
          +'<div style="text-align:right;">'
          +'<p style="font-size:13px;font-weight:600;color:#1a3d2b;margin:0 0 8px;">'+formatMoney(item.final_line_price)+'</p>'
          +'<button data-remove-item data-key="'+item.key+'" style="background:none;border:none;cursor:pointer;font-size:11px;color:#aaa;text-decoration:underline;">Hapus</button>'
          +'</div>'
          +'</div>';
      });
      html+='</div>';
      body.innerHTML=html;

      // qty change
      body.querySelectorAll('[data-change-qty]').forEach(function(btn){
        btn.addEventListener('click',function(){
          var key=btn.dataset.key;
          var delta=parseInt(btn.dataset.delta);
          // find current qty
          var qtyEl=btn.parentElement.querySelector('span');
          var current=parseInt(qtyEl?qtyEl.textContent:1);
          var newQty=Math.max(0,current+delta);
          changeQty(key,newQty);
        });
      });
      // remove
      body.querySelectorAll('[data-remove-item]').forEach(function(btn){
        btn.addEventListener('click',function(){changeQty(btn.dataset.key,0)});
      });
    }).catch(function(){
      body.innerHTML='<p style="text-align:center;padding:2rem;color:#888;font-size:13px;">Gagal memuat keranjang.</p>';
    });
  }

  function changeQty(key,qty){
    window.fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
      .then(function(r){return r.json()})
      .then(function(cart){
        updateCartBadge(cart.item_count);
        renderCart();
      }).catch(function(){});
  }

  function updateCartBadge(count){
    var badge=document.querySelector('.cart-badge');
    if(badge){badge.textContent=count;badge.classList.toggle('show',count>0)}
  }

  function formatMoney(cents){
    return '$'+(cents/100).toFixed(2);
  }

  // Filter tabs
  document.querySelectorAll('.filter-tab').forEach(function(tab){
    tab.addEventListener('click',function(){
      document.querySelectorAll('.filter-tab').forEach(function(t){t.classList.remove('active')});
      tab.classList.add('active');
    });
  });

  // Fetch cart count on load
  window.fetch('/cart.js').then(function(r){return r.json()}).then(function(cart){
    updateCartBadge(cart.item_count);
  }).catch(function(){});

  // Add to cart
  document.querySelectorAll('[data-add-to-cart]').forEach(function(btn){
    btn.addEventListener('click',function(e){
      e.preventDefault();
      var id=btn.dataset.variantId;
      if(!id)return;
      btn.disabled=true;btn.textContent='Adding...';
      window.fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:id,quantity:1})})
        .then(function(r){
          if(r.ok){
            btn.textContent='Added!';
            setTimeout(function(){
              btn.disabled=false;btn.textContent='+ Add to Cart';
              openCart(true);
            },600);
          } else {
            btn.disabled=false;btn.textContent='+ Add to Cart';
          }
        })
        .catch(function(){btn.disabled=false;btn.textContent='+ Add to Cart'});
    });
  });

  // Scroll animation
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(e){if(e.isIntersecting){e.target.style.opacity='1';e.target.style.transform='translateY(0)';io.unobserve(e.target)}});
  },{threshold:.1,rootMargin:'0px 0px -30px 0px'});
  document.querySelectorAll('.product-card,.feature-item').forEach(function(el){
    el.style.opacity='0';el.style.transform='translateY(16px)';el.style.transition='opacity .5s ease,transform .5s ease';io.observe(el);
  });
});


// PRE-ORDER COUNTDOWN
function formatCountdown(targetDate) {
  var now = new Date();
  var target = new Date(targetDate);
  var diff = target - now;
  if (diff <= 0) return null; // sudah lewat — tampilkan harga
  var days = Math.floor(diff / (1000 * 60 * 60 * 24));
  var hrs  = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  if (days > 0) return days + 'h ' + hrs + 'j lagi';
  if (hrs > 0)  return hrs + 'j ' + mins + 'm lagi';
  return mins + ' menit lagi';
}

function initPreorders() {
  document.querySelectorAll('.preorder-countdown').forEach(function(el) {
    var date = el.dataset.date;
    if (!date) return;
    function tick() {
      var label = formatCountdown(date);
      if (label === null) {
        // Waktunya sudah tiba — tampilkan harga, sembunyikan countdown
        var card = el.closest('.product-card');
        if (card) {
          card.querySelectorAll('.preorder-price-hidden').forEach(function(h){ h.style.display='none'; });
          card.querySelectorAll('.preorder-price-show').forEach(function(s){ s.style.display=''; });
          var btn = card.querySelector('.product-card-img');
          // tambahkan tombol add to cart jika belum ada
          if (btn && !btn.querySelector('[data-add-to-cart]')) {
            var variantId = card.dataset.variantId;
            if (variantId) {
              var b = document.createElement('button');
              b.className = 'btn btn-primary quick-add';
              b.setAttribute('data-add-to-cart','');
              b.setAttribute('data-variant-id', variantId);
              b.textContent = '+ Add to Cart';
              btn.appendChild(b);
            }
          }
          var badge = card.querySelector('.preorder-badge');
          if (badge) badge.remove();
        }
      } else {
        el.textContent = label;
        setTimeout(tick, 60000);
      }
    }
    tick();
  });
}

document.addEventListener('DOMContentLoaded', initPreorders);
